// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Delivery48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Delivery48: FC<Delivery48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M11.206 39.975c-1.637 0-3.031-.574-4.181-1.721-1.15-1.147-1.725-2.54-1.725-4.18H2v-23.05c0-.8.3-1.5.9-2.1.6-.6 1.3-.9 2.1-.9h28.95v8.35h5.25l6.8 9.05v8.65h-3.55c0 1.64-.573 3.033-1.719 4.18-1.146 1.147-2.538 1.72-4.175 1.72s-3.031-.573-4.181-1.72-1.725-2.54-1.725-4.18H17.1c0 1.634-.573 3.026-1.719 4.176-1.146 1.15-2.538 1.725-4.175 1.725Zm-.006-3c.8 0 1.483-.283 2.05-.85.567-.567.85-1.25.85-2.05 0-.8-.283-1.483-.85-2.05a2.794 2.794 0 0 0-2.05-.85c-.8 0-1.483.283-2.05.85a2.794 2.794 0 0 0-.85 2.05c0 .8.283 1.483.85 2.05.567.567 1.25.85 2.05.85Zm-6.2-5.9h1.1a6.617 6.617 0 0 1 2.152-2.15c.868-.533 1.835-.8 2.9-.8s2.04.275 2.923.825a6.967 6.967 0 0 1 2.175 2.125h14.7v-20.05H5v20.05Zm31.55 5.9c.8 0 1.483-.283 2.05-.85.567-.567.85-1.25.85-2.05 0-.8-.283-1.483-.85-2.05a2.794 2.794 0 0 0-2.05-.85c-.8 0-1.483.283-2.05.85a2.794 2.794 0 0 0-.85 2.05c0 .8.283 1.483.85 2.05.567.567 1.25.85 2.05.85Zm-2.6-10.2h9.3l-5.55-7.4h-3.75v7.4Z" />
        </svg>
    );
};

export default Delivery48;
